export default __webpack_public_path__ + "static/media/rambouillet12.c8788431.jpg";